export const handleRecommendation = (rec) => {
    const ktag = rec.dataset.ktag;
    const kid = rec.dataset.kid;
    const cat = rec.dataset.cat;
    const pdp = rec.dataset.pdp;
    fetch('/api/klevu' + "?ktag=" + ktag + "&kid=" + kid + "&cat=" + cat,
    {
        method: 'GET',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'litium-request-context': JSON.stringify(
                window.__litium.requestContext
            )
        }
    })
    .then(response => response.text())
    .then(data => {
        rec.innerHTML = '';
        const pageHtml = new DOMParser().parseFromString(data, 'text/html');
        if (pageHtml){
            const childNodes = pageHtml.querySelectorAll('li');
            if (childNodes) {
                if (pdp==='true'){
                    rec.appendChild(pageHtml.querySelector('div'));
                }
                else{
                    rec.appendChild(pageHtml.querySelector('ul'));
                }
            }
            rec.classList.remove('hiddenblock');
            window.__litium.bootstrapComponents();
        }
    });
}